import { HStack, Radio, RadioGroup } from "widgets";

import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";

/**
 * Boolean input field for advanced search criteria.
 */
export default function AdvancedSearchBoolean(props: IAdvancedSearchFieldProps) {
  return (
    <RadioGroup
      defaultValue={props.filterOperation.value as string}
      isRequired={true}
      key={`advanced-search-radio-${props.field.input?.name}-${props.filterOperation.value}`}
      onChange={(value) => props.onChangeState({ value })}
    >
      <HStack spacing={10} style={{ justifyContent: "space-around" }}>
        <Radio key="true" value="true">
          Yes
        </Radio>
        <Radio key="false" value="false">
          No
        </Radio>
      </HStack>
    </RadioGroup>
  );
}
